module.exports = __webpack_public_path__ + "static/media/boy-laugh.338274c8.ogg";